import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArtFirstRunPods = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 420 180",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				"data-pod": "",
				x: 250,
				y: 30,
				width: 16,
				height: 16,
				rx: 5,
				opacity: .25,
				transform: "rotate(-8 258 38)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				"data-pod": "",
				x: 300,
				y: 70,
				width: 20,
				height: 20,
				rx: 6,
				opacity: .32,
				transform: "rotate(6 310 80)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				"data-pod": "",
				x: 340,
				y: 20,
				width: 18,
				height: 18,
				rx: 5,
				opacity: .4,
				transform: "rotate(-5 349 29)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				"data-pod": "",
				x: 370,
				y: 104,
				width: 24,
				height: 24,
				rx: 6,
				opacity: .5,
				transform: "rotate(5 382 116)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				"data-pod": "",
				x: 214,
				y: 96,
				width: 14,
				height: 14,
				rx: 4,
				opacity: .2,
				transform: "rotate(7 221 103)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				"data-pod": "",
				x: 390,
				y: 44,
				width: 22,
				height: 22,
				rx: 6,
				opacity: .55,
				transform: "rotate(-6 401 55)"
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "rotate(4 333 143)",
				children: [/* @__PURE__ */ _jsx("rect", {
					x: 320,
					y: 130,
					width: 26,
					height: 26,
					rx: 7,
					opacity: .6
				}), /* @__PURE__ */ _jsx("rect", {
					x: 329,
					y: 136,
					width: 8,
					height: 13,
					rx: 2,
					fill: "var(--pure-white)"
				})]
			})
		]
	})
});
export default SvgArtFirstRunPods;
